import { MouseEventHandler } from "react";
import { Link } from "@mui/material";
import { useTranslation } from "next-i18next";
import { ISearchWikifolio } from "src/api/client/search-autocomplete.api.types";
import { ColorKpi } from "src/components/common/ranking/color-kpi";
import { SearchItemContentStack } from "src/components-mui/common/typeahead/nav-search-item/shared/search-item-content-stack";
import { SearchItemTraderAvatar } from "src/components-mui/common/typeahead/nav-search-item/shared/search-item-trader-avatar";
import { getNavSearchItemStyles } from "src/components-mui/common/typeahead/nav-search-item/shared/styles";
import { getAutoCompleteTraderName } from "src/components-mui/common/typeahead/nav-search-item/utils/get-autocomplete-trader-name";
import { IPlacement } from "src/components-mui/common/typeahead/typeahead.types";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { getTrackingUrlParam } from "src/utils/search-tracking-util";

const NAV_WIKIFOLIO_SEARCH_ITEM_TEST_ID = "nav-wikifolio-search-item";

interface IWikifolioSearchItem {
    isSelected?: boolean;
    query?: string;
    placement: IPlacement;
    onClick?: MouseEventHandler;
}

export const WikifolioSearchItem = ({
    resourceIdentifier,
    shortDescription,
    performance,
    trader,
    isSelected = false,
    query,
    placement,
}: Omit<IWikifolioSearchItem & ISearchWikifolio, "id">) => {
    // TODO: after implementing https://wikifolio.atlassian.net/browse/WIKI-26219 please use `formatPerformance` instead of `formatPercentPerformance`
    const { t } = useTranslation("common");
    const { formatPercentPerformance } = useNumberFormatter();
    const { buildWikifolioLink } = useLinkBuilder();

    return (
        <Link
            href={buildWikifolioLink(resourceIdentifier, getTrackingUrlParam({ placement, query }))}
            data-test-id={NAV_WIKIFOLIO_SEARCH_ITEM_TEST_ID}
            underline="none"
            sx={getNavSearchItemStyles(isSelected)}
        >
            <SearchItemTraderAvatar trader={trader} />
            <SearchItemContentStack
                primaryText={shortDescription}
                secondaryText={getAutoCompleteTraderName({ trader, t })}
                query={query}
                suffix={
                    <ColorKpi as="span" fontSize="md" ml={1}>
                        {formatPercentPerformance(performance, 1)}
                    </ColorKpi>
                }
            />
        </Link>
    );
};
